import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const EmployeeContactForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    employee_id: "",
    nationality: "",
    office_email: "",
    personal_email: "",
    office_mobile: "",
    personal_mobile: "",
    whatsapp_no: "",
    office_telephone: "",
    personal_telephone: "",
    home_country_address: "",
    current_address: "",
    emergency_contacts: [
      { name: "", relation_type: "", address: "", phone: "", email: "" },
    ],
  });

  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle emergency contact change
  const handleEmergencyChange = (index, e) => {
    const { name, value } = e.target;
    const updatedContacts = [...formData.emergency_contacts];
    updatedContacts[index][name] = value;
    setFormData((prev) => ({ ...prev, emergency_contacts: updatedContacts }));
  };

  // Add a new emergency contact
  const addEmergencyContact = () => {
    setFormData((prev) => ({
      ...prev,
      emergency_contacts: [
        ...prev.emergency_contacts,
        { name: "", relation_type: "", address: "", phone: "", email: "" },
      ],
    }));
  };

  // Remove an emergency contact
  const removeEmergencyContact = (index) => {
    const updatedContacts = formData.emergency_contacts.filter(
      (_, i) => i !== index
    );
    setFormData((prev) => ({ ...prev, emergency_contacts: updatedContacts }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Convert empty strings to null
      const payload = {
        ...formData,
        employee_id: Number(formData.employee_id),
        nationality: formData.nationality || null,
        office_email: formData.office_email || null,
        personal_email: formData.personal_email || null,
        office_mobile: formData.office_mobile || null,
        personal_mobile: formData.personal_mobile || null,
        whatsapp_no: formData.whatsapp_no || null,
        office_telephone: formData.office_telephone || null,
        personal_telephone: formData.personal_telephone || null,
        home_country_address: formData.home_country_address || null,
        current_address: formData.current_address || null,
        emergency_contacts: formData.emergency_contacts.map((c) => ({
          name: c.name || null,
          relation_type: c.relation_type || null,
          address: c.address || null,
          phone: c.phone || null,
          email: c.email || null,
        })),
      };

      const response = await axios.post(
  "employees/contacts/",
  payload,
  { headers: { "Content-Type": "application/json" } }
);

      alert("Employee contacts created successfully!");
      console.log(response.data);
      navigate("/dashboard/employees/list");
    } catch (error) {
      console.error(error.response?.data || error);
      alert("Error creating employee contacts: " + JSON.stringify(error.response?.data));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Employee Contact Details</h3>
          <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4">
              <label>Employee ID</label>
              <input
                type="number"
                className="form-control"
                name="employee_id"
                value={formData.employee_id}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label>Nationality</label>
              <input
                type="text"
                className="form-control"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label>Office Email</label>
              <input
                type="email"
                className="form-control"
                name="office_email"
                value={formData.office_email}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label>Personal Email</label>
              <input
                type="email"
                className="form-control"
                name="personal_email"
                value={formData.personal_email}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label>Office Mobile</label>
              <input
                type="text"
                className="form-control"
                name="office_mobile"
                value={formData.office_mobile}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label>Personal Mobile</label>
              <input
                type="text"
                className="form-control"
                name="personal_mobile"
                value={formData.personal_mobile}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label>WhatsApp Number</label>
              <input
                type="text"
                className="form-control"
                name="whatsapp_no"
                value={formData.whatsapp_no}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label>Office Telephone</label>
              <input
                type="text"
                className="form-control"
                name="office_telephone"
                value={formData.office_telephone}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label>Personal Telephone</label>
              <input
                type="text"
                className="form-control"
                name="personal_telephone"
                value={formData.personal_telephone}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mt-3">
              <label>Home Country Address</label>
              <input
                type="text"
                className="form-control"
                name="home_country_address"
                value={formData.home_country_address}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mt-3">
              <label>Current Address</label>
              <input
                type="text"
                className="form-control"
                name="current_address"
                value={formData.current_address}
                onChange={handleChange}
              />
            </div>
          </div>

          <hr className="mt-4 mb-3" />
          <h5>Emergency Contacts</h5>

          {formData.emergency_contacts.map((contact, index) => (
            <div key={index} className="row border p-3 mb-3">
              <div className="col-md-4">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={contact.name}
                  onChange={(e) => handleEmergencyChange(index, e)}
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Relation</label>
                <input
                  type="text"
                  className="form-control"
                  name="relation_type"
                  value={contact.relation_type}
                  onChange={(e) => handleEmergencyChange(index, e)}
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Phone</label>
                <input
                  type="text"
                  className="form-control"
                  name="phone"
                  value={contact.phone}
                  onChange={(e) => handleEmergencyChange(index, e)}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={contact.email}
                  onChange={(e) => handleEmergencyChange(index, e)}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label>Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={contact.address}
                  onChange={(e) => handleEmergencyChange(index, e)}
                />
              </div>
              <div className="col-12 mt-2 text-end">
                {formData.emergency_contacts.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeEmergencyContact(index)}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          ))}

          <button
            type="button"
            className="btn btn-secondary mb-3"
            onClick={addEmergencyContact}
          >
            + Add Emergency Contact
          </button>

          <button
            type="submit"
            className="btn btn-primary ms-2"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Employee Contacts"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmployeeContactForm;
